/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accessFailed: {
    id: 'serviceDesks.accessFailed',
    defaultMessage: 'Cannot access the service desk.'
  },
  connectSuccess: {
    id: 'serviceDesks.connectSuccess',
    defaultMessage: 'Service desk was successfully connected.'
  },
  connectFailed: {
    id: 'serviceDesks.connectFailed',
    defaultMessage: 'Service desks could not be connected at this time.'
  },
  createPhoneIntegrationFail: {
    id: 'createPhoneIntegrationFail',
    defaultMessage: 'Failed to update phone integration.'
  },
  uniqueViolation: {
    id: 'uniqueViolation',
    defaultMessage: 'Unique Violation: The value ".[0-9]*" already exists'
  }
});
